import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import contractService from "../../services/contractService";

const useCoreServices = () => 
useQuery(queryKeys.coreServices, () => contractService.getCoreServices(), {
    staleTime: Infinity,
});

export default useCoreServices;